// redux/ai/aiSelectors.js
export const selectAiMessages = (state) => state.ai.messages;
export const selectAiProvider = (state) => state.ai.provider;
export const selectAiIsOpen = (state) => state.ai.isOpen;
export const selectAiStatus = (state) => state.ai.status;
export const selectAiError = (state) => state.ai.error;
export const selectAiProvidersLive = (state) => state.ai.providersLive;
export const selectAiRecent = (state) => state.ai.recent;
